import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {
  BASE_PERMISSIONS,
  baseAssignmentsActions,
  baseAssignmentsSelectors,
  BaseCoreState,
  baseDocumentActions,
  BaseInquiryService,
  BaseOfferStatus,
  BaseRolesService,
  CustomerInquiryOfferListItemResponse,
  CustomerOfferResponse,
  CustomerProfileAssignmentItemResponse,
  RequirementCategoryResponse,
} from 'base';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';

@Component({
  selector: 'base-customer-offer-master-data-tab',
  templateUrl: './base-customer-offer-master-data-tab.component.html',
})
export class BaseCustomerOfferInfoMasterDataTabComponent implements OnInit, OnChanges {
  @Input() offer: (CustomerInquiryOfferListItemResponse & { order?: number }) | CustomerOfferResponse;
  @Input() inquiryRequirementCategories: RequirementCategoryResponse[];
  candidateRequirementCategories: RequirementCategoryResponse[] = [];
  endedAssignments: CustomerProfileAssignmentItemResponse[] = [];
  distanceLabel: string = '';
  hasAdminAssignmentsPermission: boolean;
  offerStatuses = BaseOfferStatus;

  constructor(
    private store: Store<BaseCoreState>,
    private inquiryService: BaseInquiryService,
    private rolesService: BaseRolesService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.offer.currentValue) {
      this.distanceLabel = this.offer?.distance !== undefined ? `${this.offer.distance} km` : '';
      this.candidateRequirementCategories = this.offer.profile?.requirements as RequirementCategoryResponse[];
      if (this.hasAdminAssignmentsPermission) {
        this.store.dispatch(
          baseAssignmentsActions.getCandidateEndedAssignments({ payload: this.offer.profile?.id as number })
        );
      }
    }
  }

  ngOnInit(): void {
    this.store.dispatch(baseDocumentActions.getDocumentCategories());

    this.hasAdminAssignmentsPermission = this.rolesService.hasCustomerFeaturePermission(
      BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENTS
    );

    this.store
      .select(baseAssignmentsSelectors.getCandidateEndedAssignments)
      .pipe(
        filter((endedAssignmentsState) => endedAssignmentsState.ok === true),
        map((endedAssignmentsState) => endedAssignmentsState.data),
        take(1)
      )
      .subscribe((list) => {
        this.endedAssignments = list;
      });
  }

  hasRequirementInCategories(requirementCategories: RequirementCategoryResponse[], requirementId: number): boolean {
    return this.inquiryService.ungroupRequirements(requirementCategories).some((item) => item.id === requirementId);
  }

  inquiryContainsCategoryRequirements(category: RequirementCategoryResponse): boolean {
    return category.requirements.every((requirement) =>
      this.inquiryService
        .ungroupRequirements(this.inquiryRequirementCategories)
        .some((item) => item.id === requirement.id)
    );
  }
}
